if (!customElements.get('content-truncator')) {
  class ContentTruncator extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;

      this.contentWrapper = this.querySelector('.content-truncator__wrapper');
      this.content = this.querySelector('.content-truncator__content');
      this.button = this.querySelector('.content-truncator__button');
      this.label = this.button?.querySelector('.link-text');

      if (!this.contentWrapper || !this.content || !this.button) return;

      this._collapsedMaxHeight = this.contentWrapper.style.maxHeight || '';
      this._labelMore = this.button.dataset.labelMore || this.label?.textContent || '';
      this._labelLess = this.button.dataset.labelLess || this._labelMore;

      this.updateButtonVisibility();

      this.button.addEventListener('click', () => this.toggleContent());

      this._onResize = this._debounce(() => this.updateButtonVisibility(), 150);
      window.addEventListener('resize', this._onResize);
    }

    disconnectedCallback() {
      if (this._onResize) {
        window.removeEventListener('resize', this._onResize);
      }
    }

    updateButtonVisibility() {
      if (!this.contentWrapper || !this.content || !this.button) return;
      if (this.contentWrapper.classList.contains('expanded')) return;

      const contentHeight = this.content.scrollHeight;
      const wrapperHeight = this.contentWrapper.clientHeight;

      if (contentHeight > wrapperHeight) {
        this.contentWrapper.classList.add('is-expandable');
        this.button.style.display = 'inline-block';
      } else {
        this.contentWrapper.classList.remove('is-expandable');
        this.button.style.display = 'none';
      }
    }

    toggleContent() {
      if (this.contentWrapper.classList.contains('expanded')) {
        this.showLessContent();
      } else {
        this.showMoreContent();
      }
    }

    showMoreContent() {
      // Buffer: scrollHeight kann letzte Zeile/Descender unterschätzen
      const contentHeight = this.content.scrollHeight + 32;
      this.contentWrapper.style.setProperty('--max-content-height', `${contentHeight}px`);
      this.contentWrapper.classList.add('expanded');
      this._setLabel(this._labelLess);

      const onEnd = (event) => {
        if (event.propertyName !== 'max-height') return;
        this.contentWrapper.removeEventListener('transitionend', onEnd);
        if (!this.contentWrapper.classList.contains('expanded')) return;
        this.contentWrapper.style.setProperty('max-height', 'none', 'important');
        this.contentWrapper.classList.remove('overflow-hidden');
      };
      this.contentWrapper.addEventListener('transitionend', onEnd);
    }

    showLessContent() {
      const contentHeight = this.content.scrollHeight + 32;
      this.contentWrapper.style.setProperty('--max-content-height', `${contentHeight}px`);
      this.contentWrapper.style.removeProperty('max-height');
      this.contentWrapper.style.maxHeight = `${contentHeight}px`;
      this.contentWrapper.classList.add('overflow-hidden');

      // Force reflow so the browser registers the tall height before collapsing
      void this.contentWrapper.offsetHeight;

      this.contentWrapper.classList.remove('expanded');
      this.contentWrapper.style.maxHeight = this._collapsedMaxHeight;
      this._setLabel(this._labelMore);
    }

    _setLabel(text) {
      if (this.label) {
        this.label.textContent = text;
      } else {
        this.button.textContent = text;
      }
    }

    _debounce(fn, wait) {
      let timeout;
      return (...args) => {
        clearTimeout(timeout);
        timeout = setTimeout(() => fn.apply(this, args), wait);
      };
    }
  }

  customElements.define('content-truncator', ContentTruncator);
}
